<template>
  <div class="shopping-cart-quantity-manager-300 col-12 " @click="buttonFunctionWrapper">
    <div class="btn btn-sm rounded-pill position-relative col-12"
         :class="[isItemOnShoppingCart() ? 'shopping-cart-quantity-manager-300-remove':'shopping-cart-quantity-manager-300-add']">
      <span>{{ productName }}</span>

      <span class="mx-2" v-html="$t('price.price', {currency: formatNumber(productPrice.price)})"></span>


      <span class="badge badge-danger rounded-pill p-1" v-if="productPrice.offer_percent">{{
          productPrice.offer_percent
        }} %</span>

      <!--      <i class="bi my-auto shopping-cart-quantity-manager-300-icon mr-1"
               :class="[isItemOnShoppingCart() ? 'bi-x-lg':'bi-check-square-fill']"/>-->
    </div>
  </div>
</template>

<script>
import {
  deleteItem,
  shoppingCartFunctions
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import {mapGetters} from "vuex";

function watchAnyObject(
    object = {},
    methods = [],
    callbackBefore = function () {
    },
    callbackAfter = function () {
    },
) {
  for (let method of methods) {
    const original = object[method].bind(object);
    const newMethod = function (...args) {
      callbackBefore(method, ...args);
      const result = original.apply(null, args);
      callbackAfter(method, ...args);
      return result;
    };
    object[method] = newMethod.bind(object);
  }
}

export default {
  name: "ShoppingCartQuantityManager300",
  props: {
    product: {},
    subProduct: {
      default: null
    }
  },
  data() {
    return {
      order: null
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    }),
    isVariationProduct() {
      return this.product.variation == 1
    },
    productName() {
      if (this.isVariationProduct) {
        return this.productFeatureName(this.product, this.subProduct.id)
      }
      return this.product.name
    },
    productPrice() {
      let price = {
        price_without_offer: 0,
        price: 0,
        offer_percent: 0,
      }

      let calculatePrice = this.isVariationProduct ? this.calculatePriceAndOffer(this.product, this.subProduct.id) : this.calculatePriceAndOffer(this.product, null)

      price.price_without_offer = calculatePrice['price']
      price.price = calculatePrice['price'] - calculatePrice['offer']
      price.offer_percent = Math.round((calculatePrice['offer'] * 100) / price.price_without_offer)
      return price


    }
  },
  methods: {
    ...shoppingCartFunctions,
    productFeatureName,
    productFeatureSubProduct,
    setOrder() {
      if (this.isAuthenticated) {
        this.order = this.$store.getters['ShoppingCart/getSidebarBasketData']
      }
    },
    refreshComponent() {
      this.$forceUpdate();
    },
    async addToCartWrapper() {
      await this.addToCart(...arguments)
      await this.refreshComponent()
    },
    async deleteItemWrapper() {
      await deleteItem(...arguments)
      await this.$emit('updateQuantity', true)

      let storageEvent = new Event(`unauthenticatedShoppingCardData`);
      window.dispatchEvent(storageEvent);

    },
    buttonFunctionWrapper() {
      if (this.isItemOnShoppingCart()) {
        this.isVariationProduct ? this.deleteItemWrapper(this.order, this.product, this.subProduct.id) : this.deleteItemWrapper(this.order, this.product, null)

      } else {
        this.isVariationProduct ? this.addToCartWrapper(this.product, this.subProduct.id) : this.addToCartWrapper(this.product, null)
      }
    },
    isItemOnShoppingCart() {
      if (this.isVariationProduct) {
        return this.checkProductOnShoppingCart(this.product, this.subProduct.id)
      }
      return this.checkProductOnShoppingCart(this.product)
    },
  },
  mounted() {
    this.setOrder()
    watchAnyObject(
        window.localStorage,
        ['setItem'],
        () => {
        },
        async () => {
          this.refreshComponent()
        },
    );
  }
}
</script>

<style scoped>
.shopping-cart-quantity-manager-300-add {
  background: var(--primary);
}

.shopping-cart-quantity-manager-300-remove {
  background: var(--secondary);
}

.shopping-cart-quantity-manager-300 .btn {
  overflow: hidden;
}

.shopping-cart-quantity-manager-300 .btn * {
  z-index: 10;
  position: relative;
}


.shopping-cart-quantity-manager-300 .btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 150%;
  width: 200%;
  height: 200%;
  background-color: var(--secondary); /* Red color */
  border-radius: 50rem;
  animation: wave 3s linear infinite;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.shopping-cart-quantity-manager-300 .btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 150%;
  width: 200%;
  height: 200%;
  background-color: var(--secondary); /* Red color */
  border-radius: 50rem;
  animation: wave 3.1s linear infinite;
  transform: translate(-50%, -50%);
  z-index: 0;
}

@keyframes wave {
  0% {
    left: 150%;
    opacity: 0;
  }
  50% {
    left: -50%;
    opacity: 0.5;
  }
  100% {
    left: -150%;
    opacity: 0;
  }
}

</style>